import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import type { CustomFontAwesomeIconProps } from './types/custom-font-awesome-icon.props';

export const GearSlash = (props: CustomFontAwesomeIconProps) => {
  return (
    <span className="fa-layers fa-fw">
      <FontAwesomeIcon
        icon={['fass', 'gear']}
        {...props}
      />
      <FontAwesomeIcon
        icon={['fass', 'slash']}
        {...props}
      />
    </span>
  );
};
